<section class="promotion-offer py-5">
    <div class="container-xl px-4">
        <h2 class="promotion-offer__title text-center mb-5">
            {{ 'fe_coupon_promotions_offer_title' | translate }}
        </h2>
        <div class="row g-4">
            <div
                class="col-6 col-lg-3"
                *ngFor="let highlight of offerHighlights"
            >
                <div class="promotion-offer__card h-100 p-3 p-lg-4">
                    <span
                        class="promotion-offer__card__emoji"
                        aria-hidden="true"
                        >{{ highlight.emoji }}</span
                    >
                    <h3 class="promotion-offer__card__title">
                        {{ highlight.title | translate }}
                    </h3>
                    <p class="promotion-offer__card__text mb-0">
                        {{ highlight.text | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
